import axios from 'axios';
const CONTROLLER_PATH = 'Patient';
class PatientService {
    //CREATE
    create(formData) {
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }

    //READ
    getpage(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + "/getpage" + (id ? '/' + id : ''), {params: urlParameters, requestId: requestId}).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }
    get(id, requestId) {
        return axios.get(CONTROLLER_PATH + '/' + id, {requestId: requestId}).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }
    getOne(id) {
        return axios.get(CONTROLLER_PATH + '/' + id).then((response) => response.data);
    }
    getTypes() {
        return axios.get(CONTROLLER_PATH + '/getTypes').then((response) => ({
            data: response.data,
        }));
    }
    getageingmanagement(urlParameters) {
        return axios.get(CONTROLLER_PATH + '/getageingmanagement', {params: urlParameters}).then((response) => response.data);
    }

    //UPDATE
    update(id, formData) {
        //formData.append('_method', 'PUT');
        return axios
            .put(CONTROLLER_PATH + '/' + id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }
    medikreditadd(id) {
        return axios.post(CONTROLLER_PATH + '/medikreditadd/' + id).then(() => {});
    }
    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + '/' + id).then(() => {});
    }
}

export default new PatientService();
